import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { useNavigate } from "react-router-dom";

export default function Hero() {
  const navigate = useNavigate();
  return (
    <main className="hero" id="home">
      <div className="hero__ambient hero__ambient--one" />
      <div className="hero__ambient hero__ambient--two" />
      <div className="container hero__grid">
        <div className="hero__copy reveal">
          <span className="eyebrow"><i /> NHI · Symphonia</span>
          <h1>
            Beyond artificial.<br />
            <em>Back to human.</em>
          </h1>
          <p>
            A human-centered architecture for the age of intelligent machines restoring discernment,
            conscience, meaning and creative direction to the center of technology.
          </p>
          <div className="hero__actions">
            <button type="button" className="button button--primary" onClick={() => navigate("/natural-human-intelligence")}>
              Explore the shift <ArrowDownRight size={18} />
            </button>
            <a className="button button--quiet" href="/docs/symphonia-shift-nhi.pdf" target="_blank" rel="noreferrer">
              Open source document <ArrowUpRight size={17} />
            </a>
          </div>
          <div className="hero__statement">
            <span>01</span>
            <p>Technology as instrument. Humanity as conductor.</p>
          </div>
        </div>

        <div className="hero__visual reveal reveal--delay">
          <div className="hero__image-frame">
            <img src="/assets/hero-shift.webp" alt="Illustration of the shift from machine-centered AI to human-centered intelligence" />
          </div>
          <div className="hero__floating-card hero__floating-card--top">
            <small>Center of gravity</small>
            <strong>The human</strong>
          </div>
          <div className="hero__floating-card hero__floating-card--bottom">
            <small>Role of technology</small>
            <strong>The instrument</strong>
          </div>
        </div>
      </div>
    </main>
  );
}
